<template>
  <div class="collectActivities">
    <img :src="form.bannerUrl" alt="" class="banner" />
    <div class="integralStore_title">
      <h1>产品列表</h1>
    </div>
    <div style="background-color: #f5f7fa;padding-bottom: 30px;">
      <div class="integralStore">
        <div class="integralStore_sorteBox">
          <div class="integralStore_sorte">
            <p>排序：</p>
            <p
              class="integralStore_sorteP"
              :class="sorteIndex == index ? 'integralStore_sorte_active' : ''"
              v-for="(items, index) in sorteIcon"
              :key="index"
              @click="getSorteMessage(index)"
            >
              {{ items.name }} <i :class="items.icons"></i>
            </p>
          </div>
          <div class="numberBox flex">
            共 <span class="number"> {{ total }} </span> 个产品
          </div>
        </div>
        <div class="integralStore_Mess" v-if="!sroreShow">
          <div
            class="integralStore_box"
            v-for="(items, index) in imtegralStoreList"
            :key="index"
            @click="handGoodsDetails(items.goodsUuid)"
          >
            <img :src="items.goodsImg" alt="" />
            <div class="integralStore_boxmess">
              <div class="flex brandBox" style="justify-content: center;">
                <p class="brand" v-if="items.brand">{{ items.brand }}</p>
                <h2>{{ items.goodsName }}</h2>
              </div>
              <p>{{ items.storeName }}</p>
              <span
                style="
                  text-decoration: line-through;
                  font-size: 12px;
                  color: #ccc;
                "
                >¥ {{ items.goodsOrigPrice }}</span
              >
              <span>¥ {{ items.goodsPrice }}</span>
            </div>
          </div>
        </div>
        <el-empty description="暂无参与活动的商品" v-else></el-empty>
      </div>
      <el-pagination
        v-if="!sroreShow"
        background
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        layout="total,prev, pager, next,jumper"
        :current-page="current"
        :page-size="pageSize"
        :total="total"
        class="pagination"
      >
      </el-pagination>
      <div class="integralStore_title">
        <h1>参与活动的店铺</h1>
      </div>
      <div class="flex collectImgbox" v-if="!collectShow">
        <div v-for="(item, index) in collectComList" :key="index" @click="onClickCom(item.enterpriseUuid)">
          <el-image
            class="imgColl"
            :src="item.logo"
          ></el-image>
        </div>
      </div>
      <el-empty description="暂无参与活动店铺" v-else></el-empty>
    </div>
  </div>
</template>

<script>
import {
  activityInfo,
  activityShopList,
  activityStoreInfo,
} from "../../utils/interface";

export default {
  name: "collectActivities",
  data() {
    return {
      collectComList: [],
      sorteIcon: [
        {
          name: "销量",
          icons: "el-icon-top",
        },
        {
          name: "人气",
          icons: "el-icon-bottom",
        },
        {
          name: "集采价格",
          icons: "el-icon-bottom",
        },
      ],
      sorteIndex: null,
      imtegralStoreList: [],
      form: {},
      current: 1,
      pageSize: 20,
      total: 0,
      uuid: "",
      sort: "",
      order: "",
      endTime: "",
      collectShow: false,
      sroreShow: false,
    };
  },
  created() {
    this.uuid = this.$route.params.uuid;
    this.getActivityInfo(this.uuid);
    this.getActivityShopList();
    this.getCurrentMonthLast();
    this.getCollectStore(this.uuid);
  },
  methods: {
    getActivityInfo() {
      activityInfo(this.uuid).then((res) => {
        if (res.success) this.form = res.data;
      });
    },
    getActivityShopList() {
      let param = {
        activityUuid: this.uuid,
        current: this.current,
        pageSize: this.pageSize,
        sort: this.sort,
        order: this.order,
      };
      activityShopList(param).then((res) => {
        if (res.success) {
          this.sroreShow = false;
          this.imtegralStoreList = res.data.list;
          if (res.data.list.length == 0) {
            this.sroreShow = true;
          }
          this.total = res.data.total;
          this.pageSize = res.data.size;
          this.current = res.data.current;
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.current = val;
      window.scrollTo(0, 0);
      this.getActivityShopList();
    },
    getSorteMessage(index) {
      this.sorteIndex = index;
      this.sorteIcon[index].icons == "el-icon-top"
        ? (this.sorteIcon[index].icons = "el-icon-bottom")
        : (this.sorteIcon[index].icons = "el-icon-top");

      if (index == 0) {
        this.sort = "SALE_NUM";
      } else if (index == 1) {
        this.sort = "t.VIEW_NUM";
      } else if (index == 2) {
        this.sort = "GOODS_PRICE";
      }
      if (this.sorteIcon[index].icons == "el-icon-top") {
        this.order = "ASC";
      } else {
        this.order = "DESC";
      }
      this.getActivityShopList();
    },
    getCurrentMonthLast() {
      let date = new Date();
      let currentMonth = date.getMonth();
      let nextMonth = ++currentMonth;
      let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      let oneDay = 1000 * 60 * 60 * 24;
      let lastTime = new Date(nextMonthFirstDay - oneDay);
      let month = parseInt(lastTime.getMonth() + 1);
      let day = lastTime.getDate();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      this.endTime = date.getFullYear() + "年" + month + "月" + day + "日";
    },
    handGoodsDetails(goodUuid) {
      if (this.form.activityProcess == "PROCESSING") {
        let routeData = this.$router.resolve({
          name: "collectShopGoodDetails",
          query: {
            activeUuid: this.uuid,
            goodUuid: goodUuid,
            activityType: this.form.activityType,
          },
        });
        window.open(routeData.href, "_blank");
      } else {
        this.$message.warning(
          `活动${this.form.activityProcesseCn}，将前往商品页进行购买！`
        );
        setTimeout(() => {
          let routeData = this.$router.resolve({
            name: "shopGoodDetails",
            params: { uuid: goodUuid },
          });
          window.open(routeData.href, "_blank");
        }, 1000);
      }
    },
    // 获取参与活动的店铺
    getCollectStore(uuid) {
      activityStoreInfo({ activityUuid: uuid, activityType: "CENTRAL" }).then(
        (res) => {
          if (res.success) {
            this.collectShow = false;
            this.collectComList = res.data.list;
            if (res.data.list.length == 0) {
              this.collectShow = true;
            }
          }
        }
      );
    },
    onClickCom(uuid) {
      if(uuid) {
        let routeData = this.$router.resolve({
          name: "printServiceIndex",
          params: { enterPriseId: uuid },
        });
        window.open(routeData.href, "_blank");
      }else {
        this.$message.warning(
          `该商铺无详情`
        );
      }
    },
  },
};
</script>

<style lang="less" scoped>
.banner {
  width: 100%;
  display: block;
}
.myIntegral {
  padding: 25px 0 21px;
  background: rgba(233, 239, 251);
  margin-bottom: 15px;
  .myIntegral_box {
    margin: 0 auto;
    width: 1200px;
    .myIntegral_box_top {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: rgba(0, 0, 0, 0.85);
      img {
        width: 21px;
        margin-right: 10px;
      }
      .myIntegral_box_top_number {
        font-size: 18px;
        font-weight: bold;
        color: #009999;
        margin-left: 11px;
      }
    }
    .text {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.85);
      margin-top: 3px;
    }
  }
}
.integralStore_title {
  width: 1200px;
  margin: 0 auto;
  // background: url("../../../src/assets/integral/integralStore.png") no-repeat;
  // background-size: 100% 100%;
  padding: 24px 0 15px;
  box-sizing: border-box;
  h1 {
    font-size: 24px;
    margin-bottom: 7px;
  }
  p {
    font-size: 18px;
  }
}
.integralStore {
  width: 1200px;
  margin: 0 auto 10px;
  padding-top: 20px;
  .integralStore_sorteBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .numberBox {
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 5px;
      .number {
        color: #009999;
        margin: 0 3px;
      }
    }
  }
  .integralStore_sorte {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #262626;
    margin-bottom: 10px;
    .integralStore_sorteP {
      cursor: pointer;
    }
    .integralStore_sorte_active {
      color: #009999;
    }
    p {
      margin-right: 20px;
    }
  }
  .integralStore_Mess {
    display: flex;
    flex-wrap: wrap;
  }
  .integralStore_box {
    width: 216px;
    margin-right: 30px;
    margin-bottom: 30px;
    cursor: pointer;
    &:nth-of-type(5n + 5) {
      margin-right: 0;
    }
    img {
      width: 100%;
      height: 138px;
      display: block;
    }
    .integralStore_boxmess {
      color: #0f1826;
      background: #fff;
      padding: 10px;
      text-align: center;
      h2 {
        font-size: 16px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      p {
        font-size: 10px;
        margin: 8px 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span {
        font-size: 12px;
        font-weight: bold;
        color: #ff0000;
      }
    }
  }
}
.el-pagination {
  width: 1200px;
  margin: 0 auto;
  text-align: right;
  margin-bottom: 30px;
}
.collectImgbox {
  width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
  display: grid;
  grid-template-columns: 224px 224px 224px 224px 224px;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  .imgColl {
    width: 224px;
    height: 80px;
    border-radius: 8px;
    border: 1px solid #eeeeee;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 1px 20px 3px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/collect/collectActivities.vue